(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["le-business"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const rail = root.querySelector('.lob-logos');
    if (rail) {
      const button = root.querySelector('.lob-motion');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const originals = [...rail.children];
      originals.forEach(item => {
        const clone = item.cloneNode(true);
        clone.classList.add('lob-logo-clone');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('data-shopify-editor-block');
        rail.append(clone);
      });
      button.hidden = false;
      let paused = false, hover = false, focused = false, visible = false, last = 0, position = 0, frame;
      const stop = () => {
        paused = true;
        button.setAttribute('aria-pressed', 'true');
        button.firstElementChild.textContent = '▶';
      };
      button.addEventListener('click', () => {
        paused = !paused;
        button.setAttribute('aria-pressed', String(paused));
        button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        position = rail.scrollLeft;
      });
      rail.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hover = true; });
      rail.addEventListener('pointerleave', () => { hover = false; });
      rail.addEventListener('focusin', () => { focused = true; });
      rail.addEventListener('focusout', () => { focused = false; });
      rail.addEventListener('pointerdown', stop, {passive:true});
      rail.addEventListener('wheel', stop, {passive:true});
      rail.addEventListener('keydown', stop);
      const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
      observer.observe(rail);
      const tick = time => {
        if (!root.isConnected) { observer.disconnect(); return; }
        const delta = last ? Math.min(time - last, 50) : 0;
        last = time;
        if (!paused && !hover && !focused && visible && !motion.matches && !document.hidden) {
          const cycle = rail.children[originals.length].offsetLeft - rail.children[0].offsetLeft;
          if (cycle > 0) {
            position = (position + delta * .028) % cycle;
            rail.scrollLeft = position;
          }
        } else position = rail.scrollLeft;
        frame = requestAnimationFrame(tick);
      };
      frame = requestAnimationFrame(tick);
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) { cancelAnimationFrame(frame); observer.disconnect(); }
      }, {once:true});
    }
    const form = root.querySelector('form');
    const request = root.querySelector('select[data-inquiry-type]');
    if (!request) return;
    const groups = root.querySelectorAll('[data-fields]');
    const update = () => {
      groups.forEach(group => {
        const show = group.dataset.fields === 'giftcards' ? request.value === 'giftcards' : request.value !== 'giftcards';
        group.hidden = !show;
        group.disabled = !show;
      });
    };
    request.addEventListener('change', update);
    update();
    root.querySelectorAll('[data-request]').forEach(link => link.addEventListener('click', () => {
      request.value = link.dataset.request;
      update();
      const product = root.querySelector('select[name="contact[Product]"]');
      if (product && link.dataset.product) product.value = link.dataset.product;
    }));
    const date = root.querySelector('input[type="date"]');
    if (date) {
      const now = new Date();
      date.min = `${now.getFullYear()}-${String(now.getMonth()+1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')}`;
    }
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    root.querySelectorAll('a[href^="#lob-"]').forEach(link => link.addEventListener('click', event => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('#shopify-section-header');
      const headerStyle = header ? getComputedStyle(header) : null;
      const fixedHeader = headerStyle && ['fixed', 'sticky'].includes(headerStyle.position);
      const inset = fixedHeader ? header.getBoundingClientRect().height + 24 : 24;
      window.scrollTo({top: Math.max(0, target.getBoundingClientRect().top + window.scrollY - inset), behavior: reduced.matches ? 'instant' : 'smooth'});
      target.setAttribute('tabindex', '-1');
      target.focus({preventScroll:true});
      history.replaceState(null, '', link.hash);
    }));
    if (!reduced.matches && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('lob-in-view');
          observer.unobserve(entry.target);
        });
      }, {threshold:0.1});
      root.querySelectorAll('.lob-product, .lob-copy, .lob-form-panel, .lob-use-grid article').forEach(el => observer.observe(el));
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(root)) observer.disconnect();
      }, {once:true});
    }
    const errors = root.querySelector('.lob-errors');
    if (errors) errors.focus();
  };
  document.querySelectorAll('[data-le-business]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-le-business]').forEach(init));
})();


  } catch(e) { console.error(e); }
})();
})();
